import React, { useContext, useEffect, useState } from "react";
import { JSDCContext, JSDCProvider } from "jsdc-dui/dist/JSDC/Context";
import JSDC from "jsdc-dui/dist/JSDC";
import { latLng, latLngBounds } from "leaflet";
import {
  IDuiContextProviderProps,
  DuiContextProvider,
} from "jsdc-dui/dist/components/Context";
import DguideWalksApp from "jsdc-dui/dist/components/DguideWalksApp";
import { DguidewalksProvider } from "jsdc-dui/dist/JSDC/Dguidewalks/Context";
import "jsdc-dui/dist/style/index.css";
import "./index.scss";
import ConfigProvider from "jsdc-dui/dist/JSDC/Dguidewalks/ConfigProvider";
import headerImg from "./assets/key-art_desktop.png";
import headerImgMb from "./assets/key-art_mobile.jpg";
import aboutImg from "./assets/intro-photo.png";

//TODO: EVENT_ID
const EVENT_ID = "e0002";

//TODO: aboutWalkContent
const aboutWalkContent = `書流山田，田象徵孕育作物的地方，是農業社會的重要資源，代表著豐饒和繁榮。稻米是台灣傳統主食。因此，“田”字象徵著勤勞、豐收和生活的基礎。而富里群山環繞，位在中央山脈與海岸山脈之間，而作物皆須由幼苗至收穫的階段，也意味著閱讀這件事情必須在地方慢慢發酵、需要時間匯集，而不論透過書展、走讀、講座、繪本的創作，都是在講述這個｢長｣出來的歷程，更顯珍貴。由黃宣衛老師所觀察到的池上經驗，再對比鄰近的富里鄉，以同為花蓮人的角度，談談眼中的池上和富里。`;
const credit = `
本路線由文化部獎勵實體書店串連辦理「創新書市 庄頭書展」創新書市之焦點活動之一，由天賜糧源與米米書店規劃，邀請黃宣衛老師將所觀察到的池上經驗，再對比鄰近的富里鄉，以同為花蓮人的角度，談談眼中的池上和富里。為一條從推廣閱讀出發，結合作者研究成果與社區參與完成的走讀路線。
`;

const duiConfigProps: IDuiContextProviderProps = {
  sidebarTitle: "",
  sidebarSubtitle: "",
  aboutWalkImgSrc: aboutImg,
  aboutWalkContent,
  credit,
  creditHref: "https://www.facebook.com/JRSHENDigitalCulture/",
  headerMBImgSrc: headerImgMb,
  headerDImgSrc: headerImg,
  menuSwitchItems: [{ id: "數位集章", name: "數位集章" }],
  weatherConfig: {
    token: "CWB-232A270E-12F1-4381-B9F2-DF2D2670A077",
    locations: [
      { county: "花蓮縣", town: "富里鄉" },
      { county: "臺東縣", town: "池上鄉" },
    ], //TODO: weather 氣象預測地點
  },
  themeConfig: {
    "--dui-primary": "#E87115", //TODO: theme
    "--dui-accent": "#00B8E8", //TODO: 數位集章按鈕顏色
    "--dui-secondary": "#E87115", //TODO: theme
    "--dui-bg-secondary": "#ffc361", // Dialog background
    "--dui-bg-accent": "#6DB2E5", //TODO: background
  },
  settingConfig: {
    disabled: true, // 左側選單不出現「工具設定」
    // languageSwitcherDisabled: true, // 或：保留「工具設定」，只藏語言切換器
  },
};

// 景點的 icon、點擊開集章卡片、cluster、集章 key、`?id=` 深連結、
// 列表的定位與導航、底圖、線都由 jsdc-dui 依 Strapi 的資料建立，這裡不需要再處理圖層。
function App() {
  const { Jsdc } = useContext(JSDCContext);

  useEffect(() => {
    (window as any).JSDC = Jsdc;
  }, [Jsdc]);

  // const paths = [
  //   { name: "看海步道", color: "#3ebff0" },
  //   { name: "雞母嶺古道", color: "#16f946" },
  //   { name: "看布袋戲", color: "#f75d19" },
  //   { name: "徒步上學", color: "#b529ff" },
  //   { name: "田埂路", color: "#f4d121" },
  // ]

  return (
    <div className="root">
      <DguideWalksApp
      language="zh-TW"
      //! 左側數位集章選項
      // mainMenuChildren={
      //   <MenuItemWithDialog
      //     Icon={Checkin}
      //     title="數位集章"
      //     active={dui.activeMenuId === '數位集章'}
      //     {...dui.menuSwitcherAction('數位集章')}
      //   >
      //     {dui.activeMenuId === '數位集章' && (
      //       <iframe
      //         title="數位集章"
      //         style={{ height: '100%', border: 0, borderRadius: '5px' }}
      //         src={`https://map.jsdc.com.tw/tools/checkin/${EVENT_ID}/showlist.php?a=${EVENT_ID}`}
      //       ></iframe>
      //     )}
      //     {/* {paths.map(path => (
      //     <div
      //       key={path.name}
      //       style={{
      //         display: "flex",
      //         alignItems: "center",
      //         margin: "20px",
      //       }}
      //     >
      //       <div
      //         style={{
      //           width: "50px",
      //           height: "5px",
      //           backgroundColor: path.color,
      //           alignItems: "center",
      //           marginRight: "10px",
      //         }}
      //       ></div>
      //       <span
      //         style={{
      //           fontSize: "20px",
      //           color: "#000",
      //           // fontWeight: "bold",
      //         }}
      //       >{` ：${path.name}`}</span>
      //     </div>
      //   ))} */}
      //   </MenuItemWithDialog>
      // }
      />
    </div>
  );
}

const config = new ConfigProvider({ eventId: EVENT_ID });

const AppWrapper: React.FC = () => {
  const [Jsdc] = useState(
    new JSDC(EVENT_ID, {
      bound: latLngBounds(
        //TODO: map view bound
        latLng(23.17837584885562, 121.23604658219013),
        latLng(23.086261042024596, 121.21150375287928),
      ),
      maxZoom: 20,
    }),
  );

  return (
    <JSDCProvider Jsdc={Jsdc}>
      <DguidewalksProvider
        Jsdc={Jsdc}
        config={config}
      >
        <DuiContextProvider {...duiConfigProps}>
          <App />
        </DuiContextProvider>
      </DguidewalksProvider>
    </JSDCProvider>
  );
};

export default AppWrapper;
